<template>
  <div class="text-start">
    <h1>Privacy Policy</h1>
    <strong>Responsible Authority</strong><br />
    <span>Jan Oliver Kolb</span><br />
    <span>Igelhecke 17</span><br />
    <span>89518 Heidenheim an der Brenz</span><br />
    <span>janoliverkolb@hotmail.de</span><br /><br />

    <strong>Data collection on this website</strong> <br />
    <span
      >This website collects and saves data entered by the user. This includes
      username, password (stored in hashed form), event data and goal
      data.</span
    ><br />
    <span
      >This data is used solely to provide the functionality of this service and
      is not shared with any third party beyond the hosting provider named
      below.</span
    ><br />
    <span
      >Legal basis: Art. 6 (1)(a) GDPR (consent), given when creating an
      account.</span
    ><br /><br />

    <strong>Storage duration</strong><br />
    <span
      >Your data is stored until you delete your account, or request deletion by
      contacting the address above. Deletion will be carried out without undue
      delay.</span
    >

    <strong>Hosting</strong><br />
    <span
      >This website is hosted on a server provided by Hetzner Online GmbH,
      located in Finland. A data processing agreement (Art. 28 GDPR) is in place
      with this provider.</span
    ><br />
    <span
      >The hosting provider automatically collects technical data for security
      and stability purposes, such as IP address, browser type, and device type
      (server log files). This data is processed on the basis of Art. 6 (1)(f)
      GDPR (legitimate interest in secure and stable operation of the
      website).</span
    ><br /><br />

    <strong>Your rights</strong><br />
    <span
      >You have the right to: <br />- request access to the personal data stored
      about you (Art. 15 GDPR)<br />- request correction of inaccurate data
      (Art. 16 GDPR) <br />- request deletion of your data (Art. 17 GDPR)<br />-
      object to processing based on legitimate interest (Art. 21 GDPR)<br />-
      withdraw your consent at any time with effect for the future (Art. 7 (3)
      GDPR)</span
    ><br />
    <span
      >To exercise any of these rights, please contact the address given
      above.</span
    >
    <br />
    <span
      >You also have the right to lodge a complaint with a data protection
      supervisory authority if you believe your data is being processed
      unlawfully.</span
    >

    <strong>Encryption</strong><br />
    <span
      >This website uses TLS encryption to protect data transmitted between your
      browser and the server.
    </span>
  </div>
</template>
